import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { ActionItemSummaryDto, FetchError, queryKeys, useAccessToken } from "src/http";

const useGetActionItemSummaryRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getActionItemSummaryRequest({
    queryKey,
  }: QueryFunctionContext<
    ReturnType<typeof queryKeys.actionItems.getActionItemSummary>
  >): Promise<ActionItemSummaryDto> {
    const accessToken = await getAccessToken();
    const [{ guid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/action-items/${guid}/summary`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getActionItemSummaryRequest };
};

const useGetActionItemSummary = (guid: string) => {
  const { getActionItemSummaryRequest } = useGetActionItemSummaryRequest();

  return useQuery({
    queryKey: queryKeys.actionItems.getActionItemSummary(guid),
    queryFn: getActionItemSummaryRequest,
    refetchOnMount: false,
  });
};

export { useGetActionItemSummary };
